import React from 'react';
import { Box, LinearProgress } from '@mui/material';

const LinearLoading = ({ show = false }) => {
  if (!show) return null;

  return (
    <Box sx={{ 
      width: '100%', 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      zIndex: 9999 
    }}>
      <LinearProgress />
    </Box>
  );
};

export default LinearLoading;
